/**
 * Route wrapper for /dashboards/takeovers. Creator report pages moved to their
 * own Creators dashboard (Oct 2026), so an old `?tab=creator-pages` bookmark
 * is sent there before the Takeovers permission gate or any Takeovers fetch
 * runs — the Creators route's own gate decides access.
 */

import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

export const CREATORS_DASHBOARD_ROUTE = '/dashboards/creators';

const TakeoversRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [params] = useSearchParams();
  if (params.get('tab') === 'creator-pages') return <Navigate to={CREATORS_DASHBOARD_ROUTE} replace />;
  return <>{children}</>;
};

export default TakeoversRoute;
